export default __webpack_public_path__ + "static/media/clouds.a0469c93.png";